<template>
  <div class="card">
    <div class="actions">
      <a-tooltip title="Editar">
        <a-button class="button" type="link" @click="emit('edit', condition.id)">
          <EditOutlined />
        </a-button>
      </a-tooltip>

      <a-tooltip title="Eliminar">
        <a-button class="button" type="link" @click="emit('delete', condition.id)">
          <DeleteOutlined />
        </a-button>
      </a-tooltip>
    </div>

    <div class="content">
      <p>
        <CheckCircleOutlined class="icon" />
        Si <span class="logical"> {{ TextByLogical[condition.logical_type] }} </span> de las
        condiciones lógicas coinciden:
      </p>

      <p v-for="ifElement in condition.form_if" :key="ifElement.id">
        <span class="variable"> {{ ifElement.input_label }} </span>
        {{ getTextByCondition(ifElement.condition_type, ifElement.input_type) }}
        <span class="variable"> {{ ifElement.comparison_value || "" }} </span>
      </p>

      <p>
        <CheckCircleOutlined class="icon" />
        Entonces realice las siguientes acciones:
      </p>

      <p v-for="elseElement in condition.form_else" :key="elseElement.id">
        {{ elseElement.action_type ? TextByAction[elseElement.action_type] : "" }}
        <span class="variable"> {{ elseElement.input_label }} </span>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CheckCircleOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons-vue";

import { Condition } from "@/@types/entities/forms";
import {
  TextByLogical,
  getTextByCondition,
  TextByAction,
} from "@/app/entities/utils/forms/conditionsText";

defineProps<{
  condition: Condition;
}>();

const emit = defineEmits<{
  (e: "edit", id: string): void;
  (e: "delete", id: string): void;
}>();
</script>

<style scoped lang="sass">
.button
  padding: 0
  height: 16px

.card
  width: 100%
  padding: 16px 20px
  position: relative
  background-color: white
  border-bottom: 2px solid $blue-6

.actions
  position: absolute
  right: 12px
  top: 12px
  display: flex
  align-items: center
  gap: 12px

.content
  display: flex
  flex-direction: column
  gap: 8px

  .icon
    margin-right: 6px

p
  color: $gray-9
  margin-bottom: 0

.variable
  color: $gray-7

.logical
  text-transform: lowercase
</style>
